import Link from "next/link";
import Logo from "@/app/components/icons/Logo";

export default function CareersHeader() {
	return (
		<div className="flex items-center justify-between mb-20">
			<Link href="/" aria-label="Home">
				<Logo color="#111" width={32} height={13} />
			</Link>
			<span className="text-[14px] font-[600] leading-[20px] tracking-[-0.3px]">
				Outpace Studios{"\u2122"}
			</span>
		</div>
	);
}
